import { X } from "lucide-react";
import { useError } from "../../context/ErrorProvider";

const CheckList = ({
  closeChecklist,
  handleContinueApproveAmount,
  handleBackToLoanDetailsFromChecklist,
  approvalDetails,
  setApprovalDetails,
}) => {
  const { showError } = useError();
  const checklistItems = [
    "Have you verified the member’s identity?",
    "Are all KYC documents uploaded and valid?",
    "Have you verified guarantor information and amount?",
    "Have you confirmed that this member doesn’t have outstanding loan?",
    "All documents reviewed and meet compliance standards",
    "Are the chattels enough to guarantee the loan?",
  ];
  const handleAnswer = (question, value) => {
    setApprovalDetails((prev) => {
      const currentValue = prev.checklist?.[question];
      const newValue = currentValue === value ? null : value;

      return {
        ...prev,
        checklist: {
          ...prev.checklist,
          [question]: newValue,
        },
      };
    });
  };

  return (
    <div
      onClick={(e) => {
        closeChecklist();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[550px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeChecklist}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Loan Approval Checklist
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Review and confirm all required checks before approving this loan.
            This checklist ensures due diligence in verifying the borrower's
            eligibility, loan completeness, and compliance with approval
            criteria. By completing this checklist, you acknowledge
            responsibility for the loan approval decision.
          </p>
          <div className="my-[15px] border border-[#A8A8A8] h-[320px] rounded-[5px] bg-white p-[15px] overflow-y-auto">
            {checklistItems.map((question, index) => (
              <div
                key={index}
                className="flex items-center my-[5px] justify-between"
              >
                <p className="text-[#000000] font-normal text-[14px] w-[70%]">
                  {question}
                </p>
                <div className="flex items-center gap-[10px] w-[30%] justify-end">
                  <button
                    onClick={() => handleAnswer(question, "No")}
                    className={`px-[20px] py-[5px] rounded-[5px] border ${
                      approvalDetails.checklist?.[question] === "No"
                        ? "bg-[#000000] text-[#fff]"
                        : "bg-white text-[#222222]"
                    }`}
                  >
                    No
                  </button>
                  <button
                    onClick={() => handleAnswer(question, "Yes")}
                    className={`px-[20px] py-[5px] rounded-[5px] border ${
                      approvalDetails.checklist?.[question] === "Yes"
                        ? "bg-[#00A859] text-white"
                        : "bg-white text-[#222222]"
                    }`}
                  >
                    Yes
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center mt-[20px] justify-between w-full">
            <button
              onClick={handleBackToLoanDetailsFromChecklist}
              className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#222222] font-medium"
            >
              Back
            </button>
            <div className="flex items-center justify-center gap-[10px]">
              <button
                onClick={closeChecklist}
                className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const checklist = approvalDetails.checklist || {};
                  const allAnswered = checklistItems.every(
                    (item) =>
                      checklist[item] === "Yes" || checklist[item] === "No",
                  );

                  if (!allAnswered) {
                    showError(
                      "Please answer all checklist items before continuing.",
                    );
                    return;
                  }

                  handleContinueApproveAmount();
                }}
                className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
              >
                Yes, Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckList;
